import React from 'react';
import { StepLine, StepsContainer } from './line-steps.style';

interface LineStepsProps {
    total: number;
    current: number;
    className?: string;
}

const LineSteps: React.FC<LineStepsProps> = ({ total, current, className }) => {
    return (
        <StepsContainer className={className}>
            {Array.from({ length: total }).map((_, idx) => (
                // eslint-disable-next-line react/no-array-index-key
                <StepLine key={`step-${idx}`} active={idx < current} />
            ))}
        </StepsContainer>
    );
};

export default LineSteps;
